import React from 'react';
import { isEmpty } from 'lodash';
import PublisherDetails from './components/PublisherDetails';
import CampaignDetailsPublishersLoader from '../../../../../../core/components/campaigns/campaigndetails/publishers/CampaignDetailsPublisherLoader';
import EntityCardSkeleton from '../EntityCardSkeleton';

const Publishers = ({ colStyle, selectedCampaign, chartsLoading, publisherData }) => {
  if (chartsLoading) return <EntityCardSkeleton />;
  if (isEmpty(publisherData)) return null;

  return (
    <CampaignDetailsPublishersLoader publisherDataReport={publisherData}>
      <PublisherDetails colStyle={colStyle} selectedCampaign={selectedCampaign} />
    </CampaignDetailsPublishersLoader>
  );
};

export default Publishers;
